export const numericRecordLimit = (value) => {
  const parsed = Number.parseInt(String(value ?? ""), 10);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const isPackageEvent = (eventData = {}) => Boolean(
  eventData?.autopilotAssignment?.packageId
  && eventData?.autopilotAssignment?.templateSnapshot
);

export const getRecordUsage = (eventData = {}, contactsValue = eventData?.contacts) => {
  const packageEvent = isPackageEvent(eventData);
  const used = Array.isArray(contactsValue) ? contactsValue.length : 0;
  const limit = packageEvent ? numericRecordLimit(eventData?.recordLimit) : null;
  const overage = limit === null ? 0 : Math.max(0, used - limit);
  return {
    packageEvent,
    used,
    limit,
    overage,
    overLimit: packageEvent && (limit === null || overage > 0),
  };
};

export const recordOverageMessage = ({ used, limit, overage }) => (
  limit === null
    ? `מכסת הרשומות אינה מוגדרת (${used} רשומות בשימוש). יש להגדיר Record Limit לפני הפעלת הטייס האוטומטי.`
    : `חריגה ממכסת הרשומות: ${used} / ${limit} רשומות — חריגה של ${overage}. `
      + "כל אנשי הקשר נשמרו, אך הטייס האוטומטי לא יפעיל שלבים עתידיים עד להסדרת החריגה."
);
